function groupRoles(array: any, nestedProperty: any) {
  const resultArray: any[] = [];
  const groupsMap = new Map();

  array?.forEach((obj: any) => {
    const keys = nestedProperty?.split(".");
    let value = obj;
    for (const key of keys) {
      value = value[key];
    }

    if (!groupsMap.has(value)) {
      groupsMap.set(value, []);
    }
    groupsMap.get(value).push(obj);
  });

  groupsMap.forEach((groupValue, key) => {
    const highestLevel = groupValue.reduce((maxLevel: any, item: any) => {
      return item.level > maxLevel ? item.level : maxLevel;
    }, "");

    resultArray.push({ code: key, level: highestLevel, items: groupValue });
  });

  return resultArray;
}

export default groupRoles;
